export default function MySQL_QUIZ() {
  return (
    <div>
      <h2>MySQL_QUIZ</h2>    </div>
  );
}